import "./MapMarkerTracking.scss"
import MarkerTracking from "assets/img/map-marker-tracking-list.svg?react"

import { FC, MouseEvent } from "react"

import { formatNumber } from "utils/utils"

interface IMapMarkerTrackingProps {
    number?: number
    onClick?: (e: MouseEvent) => void
}

const MapMarkerTracking: FC<IMapMarkerTrackingProps> = ({
    number,
    onClick,
}) => {
    return (
        <div className="map-marker-tracking" onClick={onClick}>
            <MarkerTracking className="d-block" />
            {typeof number === "number" &&
                <div className="map-marker-tracking__label color-white font-bold">
                    {formatNumber(number)}
                </div>
            }
        </div>
    )
}

export default MapMarkerTracking
